import React from "react";
import { Box } from "@material-ui/core";

import { Show } from "../../ListingPage";
import ShowInfo from "../ShowInfo";
import styled from "styled-components";

export interface StreamingNowProps {
  shows: Show[];
}
const StreamingNow: React.FC<StreamingNowProps> = ({ shows }) => {
  return (
    <StyledContainer>
      <Box display="flex" flexWrap="wrap" width="100%">
        {shows.map((show, index) => {
          return (
            <Item key={show.user.username + show.time.start.valueOf() + index}>
              <ShowInfo show={show} variant="square" />
            </Item>
          );
        })}
      </Box>
    </StyledContainer>
  );
};

export default StreamingNow;

const Item = styled.div`
  display: flex;
  margin: 32px 16px;
  flex-grow: 1;
  width: 100%;
  max-width: calc(20% - 32px);

  @media screen and (max-width: ${(props) => props.theme.breakpoints.md}px) {
    margin: 32px 8px;
    max-width: calc(33% - 16px);
  }

  @media screen and (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    max-width: calc(50% - 16px);
  }
`;

const StyledContainer = styled(Box)`
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid ${(props) => props.theme.colors.grey.borders};
  padding: 32px;

  @media screen and (max-width: ${(props) => props.theme.breakpoints.md}px) {
    padding: 0;
  }
`;
